import React from 'react';
import { Section } from './Section';
import { Map, TrendingUp } from 'lucide-react';
export function SolutionSection() {
  return <Section data-id="element-126">
      <div className="text-center mb-12" data-id="element-127">
        
        <h2 className="font-serif text-3xl md:text-4xl text-brown mb-4" style={{
        color: "#C4856A"
      }} data-id="element-128">
          Why this works when "tips" fail
        </h2>
        <p className="text-brown-light text-lg max-w-lg mx-auto" data-id="element-129">
          Most advice assumes naps are "available time." If naps are on you,
          naps are <strong data-id="element-130">immobility time</strong>.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8" data-id="element-131">
        {/* Mechanism 1 */}
        <div className="bg-white p-8 rounded-2xl shadow-sm border border-brown/5" data-id="element-132">
          <div className="w-12 h-12 bg-sage/20 rounded-full flex items-center justify-center mb-6 text-sage-dark" data-id="element-133">
            <Map className="w-6 h-6" data-id="element-134" />
          </div>
          <h3 className="font-serif text-2xl text-brown mb-4" data-id="element-135">
            1. The 3‑Block Day Map
          </h3>
          <p className="text-brown-light mb-4" data-id="element-136">
            You stop trying to "get everything done." You start running a day
            that has only three blocks:
          </p>
          <ul className="space-y-3 mb-6" data-id="element-137">
            <li className="flex items-start gap-2 text-sm md:text-base" data-id="element-138">
              <span className="font-bold text-sage" data-id="element-139">Reset Block:</span>
              <span className="text-brown-light" data-id="element-140">
                Food, water, bathroom, pain relief.
              </span>
            </li>
            <li className="flex items-start gap-2 text-sm md:text-base" data-id="element-141">
              <span className="font-bold text-sage" data-id="element-142">Admin Block:</span>
              <span className="text-brown-light" data-id="element-143">
                One tiny task so life doesn’t pile up.
              </span>
            </li>
            <li className="flex items-start gap-2 text-sm md:text-base" data-id="element-144">
              <span className="font-bold text-sage" data-id="element-145">Relief Block:</span>
              <span className="text-brown-light" data-id="element-146">True off-duty time.</span>
            </li>
          </ul>
          <p className="text-sm italic text-brown/80 bg-cream p-3 rounded-lg" data-id="element-147">
            Your day "counts" when you get Reset + Relief. Admin is optional.
          </p>
        </div>

        {/* Mechanism 2 */}
        <div className="bg-white p-8 rounded-2xl shadow-sm border border-brown/5" data-id="element-148">
          <div className="w-12 h-12 bg-terracotta/20 rounded-full flex items-center justify-center mb-6 text-terracotta" data-id="element-149">
            <TrendingUp className="w-6 h-6" data-id="element-150" />
          </div>
          <h3 className="font-serif text-2xl text-brown mb-4" data-id="element-151">
            2. The Put‑Down Ladder
          </h3>
          <p className="text-brown-light mb-4" data-id="element-152">
            Not "put them down drowsy." Not "leave and hope." Just tiny,
            no-drama reps that help your baby build tolerance safely.
          </p>
          <div className="flex items-center justify-between text-sm font-bold text-brown mb-6 px-4 py-3 bg-cream rounded-lg" data-id="element-153">
            <span data-id="element-154">0%</span>
            <span className="text-terracotta" data-id="element-155">→</span>
            <span data-id="element-156">30%</span>
            <span className="text-terracotta" data-id="element-157">→</span>
            <span data-id="element-158">60%</span>
          </div>
          <p className="text-brown-light" data-id="element-159">
            You do <strong data-id="element-160">one attempt a day</strong>, stop before escalation,
            and track progress like a sane person. This is practice, not a
            battle.
          </p>
        </div>
      </div>
    </Section>;
}